import { render, staticRenderFns } from "./AppointmentRescheduleClinics.vue?vue&type=template&id=4b51016f&"
import script from "./AppointmentRescheduleClinics.vue?vue&type=script&lang=js&"
export * from "./AppointmentRescheduleClinics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports